export const DINE_CASH_POLLING_LOCAL_STORAGE_KEY = "dine_cash_polling_data";

export enum PoolingMetricsSource {
    CART = "cart",
    POOL_PAGE = "pool_page",
}
